/**
 * Helper para verificar permissões do usuário.
 * Admin sempre tem todas as permissões.
 */
export const hasPermission = (user, permission) => {
  if (!user) return false;
  if (user.role === 'admin') return true;
  const perms = user.permissions || [];
  return perms.includes(permission);
};

/**
 * Rota home apropriada para o usuário: admin/manager → /dashboard,
 * demais (caixa, operador) → /pdv (ou /cash-session se ainda não houver caixa aberto)
 */
export const getHomeRoute = (user) => {
  if (!user) return '/login';
  if (user.role === 'admin' || user.role === 'manager') return '/dashboard';
  return '/pdv';
};

export const hasAnyPermission = (user, permissions = []) => {
  if (!user) return false;
  if (user.role === 'admin') return true;
  if (permissions.length === 0) return true;
  return permissions.some(p => (user.permissions || []).includes(p));
};
